// Glossary-Tooltip
// Quelle: Design-File "White Label.html" (Waterproof Relaunch 2026)
// A11y: role=tooltip, aria-describedby, Hover+Focus, Esc, auto-flip, viewport-clamp
// Daten werden via data-attributes vom dpn-glossary termWrap geliefert

export default function initGlossary() {
  const tip = document.getElementById('glossary-tooltip');
  if (!tip) return;

  const tipTerm  = tip.querySelector('[data-tip-term]');
  const tipBody  = tip.querySelector('[data-tip-body]');
  const tipLink  = tip.querySelector('[data-tip-link]');
  const tipClose = tip.querySelector('.tip-close');

  let currentTrigger = null;
  let hideTimer = null;

  function show(trigger) {
    clearTimeout(hideTimer);
    const name    = trigger.dataset.name    || trigger.textContent.trim();
    const body    = trigger.dataset.tooltip || '';
    const href    = trigger.dataset.href    || '#';
    if (!body) return;

    currentTrigger = trigger;
    tipTerm.textContent = name;
    tipBody.textContent = body;
    tipLink.href = href;
    tip.setAttribute('data-visible', 'true');
    // inert (statt aria-hidden) toggeln: .tip wird nur per opacity/pointer-events
    // versteckt, bleibt also im DOM fokussierbar. inert nimmt Tooltip-Kinder
    // (Close-Button, Glossar-Link) im Hidden-Zustand aus Tab-Flow UND A11y-Baum
    // (behebt axe aria-hidden-focus). Beim Anzeigen wieder freigeben:
    tip.removeAttribute('inert');
    trigger.setAttribute('aria-expanded', 'true');
    position(trigger);
  }

  function position(trigger) {
    const r = trigger.getBoundingClientRect();
    const tipW = tip.offsetWidth;
    const tipH = tip.offsetHeight;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const gap = 12;

    let left = r.left + r.width / 2 - tipW / 2;
    left = Math.max(16, Math.min(left, vw - tipW - 16));

    let top = r.bottom + gap;
    let placement = 'bottom';
    if (top + tipH > vh - 16 && r.top - gap - tipH > 16) {
      top = r.top - gap - tipH;
      placement = 'top';
    }

    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
    tip.setAttribute('data-placement', placement);

    const arrowX = Math.max(12, Math.min(r.left + r.width / 2 - left - 5, tipW - 24));
    tip.style.setProperty('--arrow-x', arrowX + 'px');
  }

  function hide(immediate) {
    const doHide = () => {
      tip.setAttribute('data-visible', 'false');
      tip.setAttribute('inert', '');
      if (currentTrigger) {
        currentTrigger.setAttribute('aria-expanded', 'false');
        currentTrigger = null;
      }
    };
    if (immediate) doHide();
    else {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(doHide, 180);
    }
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => hide(true), 180);
  }
  function cancelHide() { clearTimeout(hideTimer); }

  document.querySelectorAll('.glossary').forEach(t => {
    t.setAttribute('aria-expanded', 'false');
    t.setAttribute('aria-describedby', 'glossary-tooltip');
    t.setAttribute('tabindex', '0');
    if (t.tagName !== 'BUTTON') t.setAttribute('role', 'button');

    t.addEventListener('mouseenter', () => show(t));
    t.addEventListener('mouseleave', scheduleHide);
    t.addEventListener('focus', () => show(t));
    t.addEventListener('blur', (e) => {
      if (!tip.contains(e.relatedTarget)) scheduleHide();
    });
    t.addEventListener('click', (e) => {
      e.preventDefault();
      if (t.dataset.href) window.location.href = t.dataset.href;
    });
    t.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (t.dataset.href) window.location.href = t.dataset.href;
      }
    });
  });

  tip.addEventListener('mouseenter', cancelHide);
  tip.addEventListener('mouseleave', scheduleHide);
  if (tipClose) tipClose.addEventListener('click', () => hide(true));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && tip.getAttribute('data-visible') === 'true') {
      hide(true);
      if (currentTrigger) currentTrigger.focus();
    }
  });

  window.addEventListener('scroll', () => { if (currentTrigger) position(currentTrigger); }, { passive: true });
  window.addEventListener('resize', () => { if (currentTrigger) position(currentTrigger); });
}
